<template>
  <v-container
    fluid
    grid-list-md
  >
    <forms-cash-registers-open v-if="!cashRegister.openedReport" />
    <forms-cash-registers-close v-else />
  </v-container>
</template>

<script>
import Vue from 'vue'
import { mapGetters } from 'vuex'
import FormsCashRegistersOpen from '@/components/forms/cash-registers/FormsCashRegistersOpen'
import FormsCashRegistersClose from '@/components/forms/cash-registers/FormsCashRegistersClose'

export default {
  metaInfo () {
    return { title: this.pageTitle }
  },

  components: {
    FormsCashRegistersOpen,
    FormsCashRegistersClose
  },

  data: () => ({
    pageTitle: `${Vue.i18n.translate('Open/Close')} ${Vue.i18n.translate('Register')}`
  }),

  computed: {
    ...mapGetters(['cashRegister'])
  }
}
</script>



// WEBPACK FOOTER //
// src/views/cash-registers/OpenClose.vue